<bw-action-card-legacy
  @fadeIn
  [cardConfig]="welcomeVideoActionCard"
  (ctaClicked)="openVideoModal()"
></bw-action-card-legacy>

<ng-template #videoModalContent>
  <bw-video-legacy
    [showTitle]="false"
    [cdnBase]="cdnBase"
    [path]="'videos/explainer/' + languageSelectorService.activeLang + '/explainer.mp4'"
  ></bw-video-legacy>
</ng-template>